import clsx from "clsx";
import { useLayoutEffect } from "react";
import LocationSelect, { LocationDetails } from "components/Form/Select/LocationSelect";
import { useFloatingField } from "./context";
import { sizeStyles } from "./sizeStyles";

interface FloatingLocationProps {
  onChange: (value: LocationDetails) => void;
  className?: string;
  containerStyles?: object;
  initialValue?: { locationId: string; label: string };
}

function FloatingLocation({ onChange, initialValue, ...rest }: FloatingLocationProps) {
  const { setHasValue, hasValue, size } = useFloatingField();
  const styles = sizeStyles[size];

  useLayoutEffect(() => {
    setHasValue(!!initialValue);
  }, [initialValue, setHasValue]);

  return (
    <div className={clsx("floating-single-select", hasValue && "chakra-react-select--has-value")}>
      <LocationSelect
        {...rest}
        initialValue={initialValue}
        placeholder=" "
        onChange={(value) => {
          setHasValue(!!value);
          onChange(value);
        }}
        chakraStyles={{
          control: (provided: any) => ({
            ...provided,
            height: styles.inputHeight,
            minHeight: styles.inputHeight,
            maxHeight: styles.inputHeight,
            backgroundColor: "transparent",
          }),
          valueContainer: (provided: any) => ({
            ...provided,
            paddingLeft: 0,
            paddingInlineStart: 0,
          }),
        }}
      />
    </div>
  );
}

export default FloatingLocation;
